/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../../services'

 
export const getAllOrgsApps = createAsyncThunk('org/getAllOrgsApps', async (_, { rejectWithValue }) => {
    try { 
        const data = await api.orgApp
        .getAllOrgsApps()
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAllAppsByOrgID = createAsyncThunk('org/getAllAppsByOrgID', async (orgId, { rejectWithValue }) => {
    try { 
        const data = await api.orgApp
        .getAllAppsByOrgID(orgId)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAllOrgByHistory = createAsyncThunk('org/getAllOrgByHistory', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.orgApp.getAllOrgByHistory(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
